var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.235,
    height: 20.255,
    viewBox: "0 0 20.235 20.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12278",
    "data-name": "Group 12278",
    transform: "translate(-398.882 -418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12277",
    "data-name": "Group 12277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45250",
    "data-name": "Path 45250",
    d: "M3.689,16.484a4.605,4.605,0,0,1-2.006-.971A4.433,4.433,0,0,1,.021,12.077q-.045-3.783,0-7.566A4.58,4.58,0,0,1,4.154.035C4.368.015,4.583,0,4.8,0q5.39,0,10.781,0a4.58,4.58,0,0,1,4.5,3.473,4.985,4.985,0,0,1,.148,1.191c.013,2.414.01,4.829.006,7.243a4.591,4.591,0,0,1-3.712,4.568,5.288,5.288,0,0,1-1.046.091c-1.607.009-3.213,0-4.82.01a.877.877,0,0,0-.454.135q-2.493,1.649-4.974,3.317a1,1,0,0,1-.744.211.924.924,0,0,1-.79-1c0-.834,0-1.667,0-2.5v-.261M10.121,5.533H4.808a2.669,2.669,0,0,0-.322.015A.9.9,0,0,0,3.737,6.7a.929.929,0,0,0,.987.666h10.8c.05,0,.1,0,.151,0a.916.916,0,0,0,.8-1.274.929.929,0,0,0-.952-.562q-2.7.006-5.4,0m0,3.685q-1.786,0-3.571,0a1.362,1.362,0,0,0-.32.024.9.9,0,0,0-.682,1,.885.885,0,0,0,.9.791q3.679,0,7.358,0a.869.869,0,0,0,.212-.023A.9.9,0,0,0,14.7,10.01a.886.886,0,0,0-.9-.791c-1.226,0-2.453,0-3.679,0",
    transform: "translate(398.883 418)",
    fill: "#014fe0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12276",
    "data-name": "Group 12276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45251",
    "data-name": "Path 45251",
    d: "M70.755,96.219q2.7,0,5.4,0a.929.929,0,0,1,.952.562.916.916,0,0,1-.8,1.274c-.05,0-.1,0-.15,0h-10.8a.929.929,0,0,1-.987-.666.9.9,0,0,1,.75-1.155,2.66,2.66,0,0,1,.322-.015h5.312",
    transform: "translate(338.249 327.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45252",
    "data-name": "Path 45252",
    d: "M100.958,160.327c1.226,0,2.453,0,3.679,0a.886.886,0,0,1,.9.791.9.9,0,0,1-.682,1.006.866.866,0,0,1-.212.023q-3.679,0-7.358,0a.885.885,0,0,1-.9-.791.9.9,0,0,1,.682-1,1.356,1.356,0,0,1,.32-.024q1.786,0,3.571,0",
    transform: "translate(308.045 266.891)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msg_icon.50868092f572bdfb266536d917bdccac.svg";
export { ForwardRef as ReactComponent };